<template>
  <div class="section center">
    <div class="container-nuvem">
      <div
        v-for="(noticia, index) in noticias3"
        :key="noticia.classe"
        class="item"
        :class="noticia.classe"
        @click="openNoticias(index)"
      >
        {{ noticia.palavra }}
      </div>
    </div>
    <PopUpNoticias
      :isShowed="showNoticias"
      :noticias="noticias3"
      :index="indexNoticias"
      :show-proximo="false"
      v-if="showNoticias"
      @close="closeNoticias"
    ></PopUpNoticias>
    <div class="click-lelas mb-5">
      <i class="bi bi-hand-index mr-3"></i>
      Clique nas palavras para descobrir as manchetes.
    </div>
  </div>
</template>

<script>
import PopUpNoticias from "@/components/PopUpNoticias";
import { noticias3 } from "@/consts/noticias.js";
export default {
  components: {
    PopUpNoticias,
  },
  data() {
    return {
      showNoticias: false,
      noticias3,
      indexNoticias: 0,
    };
  },
  methods: {
    openNoticias(index) {
      this.indexNoticias = index;
      this.showNoticias = true;
    },
    closeNoticias() {
      this.showNoticias = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  min-height: 100vh;
}

.click-lelas {
  font-family: Roboto Condensed;
  font-size: 14px;
  line-height: 16px;
  color: #626262;
}

.container-nuvem {
  position: relative;
  width: 834.51px;
  height: 716.66px;
  transform: scale(0.8);

  .item {
    text-transform: uppercase;
    position: absolute;
    font-family: Roboto Condensed;
    color: #626262;
    font-size: 32px;
    line-height: 38px;
    position: absolute;
    font-style: normal;
    font-weight: normal;
    transform-origin: top left;
    cursor: pointer;
    white-space: nowrap;
  }

  .metas-de-vacinacao {
    width: 259px;
    height: 33px;
    left: 144.9px;
    top: 0px;
    font-size: 28px;
    line-height: 33px;
    transform: rotate(45.34deg);
  }

  .decisao-liminar {
    position: absolute;
    width: 204px;
    height: 33px;
    left: 241.98px;
    top: 270.39px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 28px;
    line-height: 33px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;

    transform: rotate(-43.18deg);
  }

  .cronogramas {
    /* cronogramas */

    position: absolute;
    width: 182px;
    height: 33px;
    left: 269.2px;
    top: 297px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 28px;
    line-height: 33px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;

    transform: rotate(44.66deg);
  }

  .aumento-das-mortes {
    position: absolute;
    width: 308px;
    height: 38px;
    left: 299.23px;
    top: 264.87px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 32px;
    line-height: 38px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;

    transform: rotate(45.77deg);
  }

  .agentes-penitenciarios {
    position: absolute;
    width: 349px;
    height: 38px;
    left: 328.44px;
    top: 236.62px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 32px;
    line-height: 38px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;

    transform: rotate(46.3deg);
  }

  .pessoas-privadas-de-liberdade {
    position: absolute;
    width: 509px;
    height: 42px;
    left: 360.26px;
    top: 204.86px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    line-height: 42px;
    text-transform: uppercase;

    color: #626262;

    transform: rotate(45.83deg);
  }

  .tribunal-de-justica {
    position: absolute;
    width: 292px;
    height: 38px;
    left: 390.46px;
    top: 177.86px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 32px;
    line-height: 38px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;

    transform: rotate(46.28deg);
  }

  .plano-de-vacinacao {
    position: absolute;
    width: 295px;
    height: 38px;
    left: 419.9px;
    top: 157.86px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 32px;
    line-height: 38px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;

    transform: rotate(45.07deg);
  }

  .nao-priorizam {
    position: absolute;
    width: 186px;
    height: 33px;
    left: 444.99px;
    top: 136px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 28px;
    line-height: 33px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;

    transform: rotate(46.62deg);
  }

  .segunda-dose {
    position: absolute;
    width: 87px;
    height: 30px;
    left: 584.53px;
    top: 283px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 26px;
    line-height: 30px;
    text-transform: uppercase;

    color: #626262;

    transform: rotate(45.87deg);
  }

  .primeira-dose {
    position: absolute;
    width: 87px;
    height: 30px;
    left: 420.53px;
    top: 446px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 26px;
    line-height: 30px;
    text-transform: uppercase;

    color: #626262;

    transform: rotate(45.87deg);
  }

  .vacina {
    position: absolute;
    width: 82px;
    height: 30px;
    left: 50px;
    top: 134.86px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 26px;
    line-height: 30px;
    text-transform: uppercase;

    color: #626262;
  }

  .vacina-2 {
    position: absolute;
    width: 82px;
    height: 30px;
    left: 529.72px;
    top: 536px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 26px;
    line-height: 30px;
    text-transform: uppercase;

    color: #626262;

    transform: rotate(46.39deg);
  }

  .vacina-3 {
    position: absolute;
    width: 82px;
    height: 30px;
    left: 661.72px;
    top: 406px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 26px;
    line-height: 30px;
    text-transform: uppercase;

    color: #626262;

    transform: rotate(46.39deg);
  }

  .mortes {
    position: absolute;
    width: 89px;
    height: 30px;
    left: 47px;
    top: 170.86px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 26px;
    line-height: 30px;
    text-transform: uppercase;

    color: #626262;
  }

  .mortes-2 {
    position: absolute;
    width: 75px;
    height: 26px;
    left: 467px;
    top: 548.18px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 22px;
    line-height: 26px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;

    transform: rotate(-44.32deg);
  }

  .mortes-3 {
    position: absolute;
    width: 89px;
    height: 30px;
    left: 586px;
    top: 424.18px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 26px;
    line-height: 30px;
    text-transform: uppercase;

    color: #626262;

    transform: rotate(-44.32deg);
  }

  .estado-do-pais {
    position: absolute;
    width: 250px;
    height: 38px;
    left: 617px;
    top: 677.18px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 32px;
    line-height: 38px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;

    transform: rotate(-46.49deg);
  }

  .falta-de-testes {
    position: absolute;
    width: 167px;
    height: 28px;
    left: 671px;
    top: 679.61px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 28px;
    text-transform: uppercase;

    color: #626262;

    transform: rotate(-47.24deg);
  }

  .socioeducativo {
    position: absolute;
    width: 173px;
    height: 28px;
    left: 695px;
    top: 697.36px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 28px;
    text-transform: uppercase;

    color: #626262;

    transform: rotate(-46.44deg);
  }

  .contagio {
    position: absolute;
    width: 112px;
    height: 30px;
    left: 35px;
    top: 206.86px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 26px;
    line-height: 30px;
    text-transform: uppercase;

    color: #626262;
  }

  .divergencia {
    position: absolute;
    width: 144px;
    height: 30px;
    left: 19px;
    top: 244.86px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 26px;
    line-height: 30px;
    text-transform: uppercase;

    color: #626262;
  }

  .dos-presos {
    position: absolute;
    width: 182px;
    height: 30px;
    left: 0px;
    top: 282.86px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 26px;
    line-height: 30px;
    text-transform: uppercase;

    color: #626262;
  }

  .vacinacao {
    position: absolute;
    width: 127px;
    height: 30px;
    left: 27.28px;
    top: 319.86px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 26px;
    line-height: 30px;
    text-transform: uppercase;

    color: #626262;

    transform: rotate(0.53deg);
  }

  .primeira-dose-2 {
    position: absolute;
    width: 87px;
    height: 30px;
    left: 48px;
    top: 358.86px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 26px;
    line-height: 30px;
    text-transform: uppercase;

    color: #626262;
  }
}

@media screen and (max-width: 900px) {
  .container-nuvem {
    transform: scale(0.7);
  }
}

@media screen and (max-width: 800px) {
  .container-nuvem {
    transform: scale(0.6);
  }
}

@media screen and (max-width: 600px) {
  .container-nuvem {
    transform: scale(0.4);
  }
}

@media screen and (max-width: 480px) {
  .container-nuvem {
    transform: scale(0.4);
  }
}
</style>